<template>
  <path
    d="M12.43 2.30019C10.05 1.71019 7.75001 2.03019 5.80001 2.94019C5.45001 3.10019 5.39001 3.58019 5.70001 3.80019C8.30001 5.60019 10 8.60019 10 12.0002C10 15.4002 8.30001 18.4002 5.70001 20.2002C5.38001 20.4202 5.44001 20.9002 5.79001 21.0602C7.07001 21.6602 8.50001 22.0002 10 22.0002C16.05 22.0002 20.85 16.6202 19.87 10.4002C19.26 6.48019 16.28 3.24019 12.43 2.30019Z"
  />
</template>
